export default "__VITE_ASSET__BrVIk76$__"